// 인앱 브라우저 감지 플러그인 (클라이언트 전용)
export default defineNuxtPlugin(() => {
  const isInAppBrowser = useState('isInAppBrowser', () => false)
  const isDetectionReady = useState('isDetectionReady', () => false)

  // 앱 시작 시 즉시 감지
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const userAgent = navigator.userAgent.toLowerCase()

    const isInApp = userAgent.match(
      /kakaotalk|line|inapp|naver|snapchat|wirtschaftswoche|thunderbird|instagram|everytimeapp|whatsApp|electron|wadiz|aliapp|zumapp|iphone(.*)whale|android(.*)whale|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS/i
    )

    isInAppBrowser.value = !!isInApp
    isDetectionReady.value = true  // 감지 완료 플래그 설정

    // console.log('🔍 Plugin - 인앱 브라우저 감지:', isInAppBrowser.value)
    // console.log('📱 UserAgent:', userAgent)
  }

  return {
    provide: {
      isInAppBrowser: readonly(isInAppBrowser),
      isDetectionReady: readonly(isDetectionReady)
    }
  }
})
